(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
    if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function(){
            if(event.target.classList.contains('swiper-slide')){
                const collectionListSwiperEl = event.target.closest('.swiper.collection-list-slider');
                let slideIndex = event.target.dataset.index;
                if(collectionListSwiperEl){
                    collectionListSwiperEl.swiper.slideTo(slideIndex);
                }
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    

    if (!Shopify.designMode){
        if (!localStorage.getItem('popupDisplayed')) {
            setTimeout(function(){
                popupShow()
                localStorage.setItem('popupDisplayed', true);
            }, 5000)
        }
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCloseBtn = newsletterPopup.querySelector('.popup-close');
        const popupCancelBtn = newsletterPopup.querySelector('.popup-cancel');
        popupCloseBtn.addEventListener('click', function(){
            popupClose()
        });
        popupCancelBtn.addEventListener('click', function(){
            popupClose()
        });
        document.addEventListener('click', function(event) {
            const popupCard = newsletterPopup.querySelector('.popup-card');
            if (!popupCard.contains(event.target)) {
                popupClose();
            }
        });
        document.addEventListener("DOMContentLoaded", function() {
            if (window.location.hash === '#popupContactForm') {
                popupShow();
            }
        });
    }

    if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                popupShow();
            }
        })
        document.addEventListener('shopify:section:deselect', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                popupClose();
            }
        })
        document.addEventListener('shopify:section:unload', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                const htmlEl = document.querySelector('html');
                htmlEl.classList.remove('popup-show');
            }
        })
    }

    function popupShow() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCard = newsletterPopup.querySelector('.popup-card');
        newsletterPopup.classList.add('show');
        htmlEl.classList.add('popup-show');
        if(Shopify.designMode){
            newsletterPopup.classList.add('fade');
        }
        setTimeout(function() {
            newsletterPopup.classList.add('fade');
            if(!Shopify.designMode){
                popupCard.focus();
            }
        }, 100);

        // Trap focus within the popup card
        popupCard.setAttribute('tabindex', '-1');
        popupCard.addEventListener('keydown', function(event) {
            trapFocus(event, popupCard);
        });
    }

    function popupClose() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        newsletterPopup.classList.remove('fade');
        setTimeout(function() {
            newsletterPopup.classList.remove('show');
            htmlEl.classList.remove('popup-show');
        }, 400);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.handleIntersection = this.handleIntersection.bind(this);
      this.recommendationSectionSlider = this.recommendationSectionSlider.bind(this);
      this.intersectionCompleted = false;
    }

    connectedCallback() {
      this.intersectionObserver = new IntersectionObserver(
        this.handleIntersection,
        { rootMargin: '0px 0px 200px 0px' }
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      const url = this.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            handleQuickView();
          }
          this.intersectionCompleted = true; // Set the flag to true after completion
          if(html.querySelector('.recommendation-list-slider')){
            this.recommendationSectionSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    recommendationSectionSlider(){
        if (!this.intersectionCompleted) return;
        const featureSlider = this.querySelector('.recommendation-list-slider');
        const section = '#' + featureSlider.id;
        const prevBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-prev');
        const nextBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-next');
        const dtSlides = featureSlider.dataset.desktopSlides;
        const sdtSlides = featureSlider.dataset.smalldesktopSlides;
        const ltSlides = featureSlider.dataset.laptopSlides;
        const tbSlides = featureSlider.dataset.tabletSlides;
        const mbSlides = featureSlider.dataset.mobileSlides;
        this.recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides);
    }
    recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides) {
        try {
          let swiper = new Swiper(section, {
                spaceBetween: 20,
                slidesPerView: mbSlides,
                allowTouchMove: true,
                navigation: {
                  prevEl: prevBtn,
                  nextEl: nextBtn
                },
                clickable: true,
                breakpoints: {
                  520: {
                    slidesPerView: mbSlides,
                  },
                  768: {
                    slidesPerView: tbSlides,
                  },
                  1024: {
                    slidesPerView: ltSlides,
                  },
                  1280: {
                    slidesPerView: sdtSlides,
                  },
                  1536: {
                    slidesPerView: dtSlides,
                  },
                },
                on: {
                  init: function () {
                    
                    $(section).removeAttr('x-swiper');
                  },
                }
            });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  /* ───────────────────────────────────────────────────────────
     Recently viewed products

     The history lives in localStorage and the cards are built in the
     browser from /products/{handle}.js, so a visitor sees their own
     browsing without an app, an account, or anything stored server
     side.

     The element ships hidden and empty. It reveals itself only once
     at least one product has been fetched, and removes itself
     otherwise, so a first-time visitor never meets a bare heading.
     ─────────────────────────────────────────────────────────── */
  (function () {
    'use strict';

    var STORAGE_KEY = 'medicore:recently-viewed';

    function readHistory() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        // Anything that is not a usable entry is discarded rather than
        // trusted - the key is writable by any other script. Entries
        // written before the state was recorded are bare handles, so
        // they are normalised rather than thrown away.
        return parsed
          .map(function (entry) {
            if (typeof entry === 'string') return { h: entry, s: '' };
            if (entry && typeof entry.h === 'string') {
              return { h: entry.h, s: typeof entry.s === 'string' ? entry.s : '' };
            }
            return null;
          })
          .filter(function (entry) {
            return entry && entry.h.length > 0;
          });
      } catch (e) {
        return [];
      }
    }

    function writeHistory(entries) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
      } catch (e) {
        /* private mode, or the quota is full - the section simply
           shows whatever history already existed */
      }
    }

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* Shopify's money format, implemented here because the cards are
       built after the page has rendered and Liquid's money filter is
       no longer available. */
    function formatMoney(cents, format) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;

      function withDelimiters(number, precision, thousands, decimal) {
        if (isNaN(number) || number === null) return '0';
        var fixed = (number / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }

      var match = format.match(placeholder);
      var value = '';

      switch (match && match[1]) {
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          value = withDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = withDelimiters(cents, 2, ' ', '.');
          break;
        default:
          value = withDelimiters(cents, 2, ',', '.');
      }

      return format.replace(placeholder, value);
    }

    function sizedUrl(url, width) {
      if (!url) return '';
      var absolute = url.indexOf('//') === 0 ? 'https:' + url : url;
      return absolute + (absolute.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function buildSrcset(url, widths) {
      return widths
        .map(function (width) {
          return sizedUrl(url, width) + ' ' + width + 'w';
        })
        .join(', ');
    }

    var RecentlyViewed = class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rv-track]');
        this.slider = this.querySelector('.recommendation-list-slider');
        this.nav = this.querySelector('[data-rv-nav]');
        if (!this.track) return;

        this.currentHandle = this.dataset.currentHandle || '';
        this.maxDisplay = parseInt(this.dataset.maxDisplay, 10) || 4;
        this.maxHistory = parseInt(this.dataset.maxHistory, 10) || 12;
        this.widths = (this.dataset.srcset || '')
          .split(',')
          .map(function (width) { return parseInt(width.trim(), 10); })
          .filter(function (width) { return !isNaN(width); });

        this.record();
        this.render();
      }

      /* Newest first, no duplicates, capped. Recording happens before
         reading, so a repeat visit moves that product to the front of
         the list it will appear in next time. */
      record() {
        if (!this.currentHandle) return;

        var current = this.currentHandle;
        var history = readHistory().filter(function (entry) {
          return entry.h !== current;
        });

        history.unshift({ h: current, s: this.dataset.currentState || '' });
        writeHistory(history.slice(0, this.maxHistory));
      }

      /* The Liquid resolver's order, as far as the JSON allows. Live
         availability wins over anything remembered: an item recorded
         as backordered that Shopify will no longer sell is out of
         stock, and no ETA can be promised for it. */
      stockState(product) {
        var remembered = (this.states || {})[product.handle];

        if (!product.available) {
          if (remembered === 'special' || this.isSpecial(product)) return 'special';
          return 'out';
        }

        if (remembered === 'backorder' || remembered === 'special') return remembered;

        return this.isSpecial(product) ? 'special' : 'in';
      }

      isSpecial(product) {
        var tag = this.dataset.specialTag;
        if (!tag || !Array.isArray(product.tags)) return false;
        return product.tags.some(function (t) {
          return String(t).toLowerCase() === tag.toLowerCase();
        });
      }

      render() {
        var self = this;
        var current = this.currentHandle;

        var entries = readHistory()
          .filter(function (entry) { return entry.h !== current; })
          .slice(0, this.maxDisplay);
        var handles = entries.map(function (entry) { return entry.h; });

        /* The card builder is handed a plain handle, so the recorded
           state is looked up by handle rather than passed down. */
        this.states = {};
        entries.forEach(function (entry) { self.states[entry.h] = entry.s; });

        if (!handles.length) {
          this.remove();
          return;
        }

        var requests = handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (response) {
              // A product that has been deleted, unpublished, or moved
              // out of this channel still sits in the visitor's
              // history. It is dropped rather than allowed to reject.
              if (!response.ok) return null;
              return response.json();
            })
            .catch(function () {
              return null;
            });
        });

        Promise.all(requests).then(function (products) {
          var valid = products.filter(function (product) {
            return product && product.handle && product.title;
          });

          if (!valid.length) {
            self.remove();
            return;
          }

          self.track.innerHTML = valid
            .map(function (product) {
              return '<div class="swiper-slide">' + self.card(product) + '</div>';
            })
            .join('');

          self.hidden = false;
          self.initSlider(valid.length);

          if (typeof handleQuickView === 'function') handleQuickView();
        });
      }

      /* Mirrors snippets/product-card.liquid. The two have to agree:
         this row sits on the same pages as server-rendered grids, and
         a card that is nearly the same is more obviously wrong than
         one that is plainly different. */
      card(product) {
        var d = this.dataset;
        var url = '/products/' + encodeURIComponent(product.handle);
        var variant = null;
        var i;

        for (i = 0; i < (product.variants || []).length; i++) {
          if (product.variants[i].available) { variant = product.variants[i]; break; }
        }
        if (!variant && product.variants && product.variants.length) variant = product.variants[0];

        var images = product.images || [];
        var featured = product.featured_image || images[0] || d.defaultImage || '';
        var second = images.length > 1 ? images[1] : '';
        var largest = this.widths[this.widths.length - 1] || 600;

        var onSale = !!(variant && variant.compare_at_price &&
          variant.compare_at_price > variant.price && variant.available);

        var html = '<article class="mc-card' + (second ? ' has-hover' : '') + '">';

        /* ── media ── */
        html += '<a class="mc-card__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">';

        function img(src, cls) {
          return '<img src="' + esc(sizedUrl(src, largest)) + '"' +
            ' srcset="' + esc(buildSrcset(src, this.widths)) + '"' +
            ' sizes="' + esc(d.sizes) + '"' +
            ' alt="' + esc(product.title) + '" loading="lazy" class="' + cls + '">';
        }

        if (featured) html += img.call(this, featured, 'mc-card__img');
        if (second) html += img.call(this, second, 'mc-card__img mc-card__img--alt');

        if (d.saleBadge === 'true' && onSale) {
          var flag = d.strSale;
          if (d.offerBadge === 'true') {
            var percent = Math.round(
              ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
            );
            if (percent > 0) flag = '−' + percent + '%';
          }
          html += '<span class="mc-card__flag">' + esc(flag) + '</span>';
        }

        html += '</a>';

        /* ── body ── */
        html += '<div class="mc-card__body">';

        if (d.vendor === 'true' && product.vendor) {
          html += '<p class="mc-card__vendor">' + esc(product.vendor) + '</p>';
        }

        html += '<h3 class="mc-card__title"><a href="' + esc(url) + '">' +
          esc(product.title || d.strTitle) + '</a></h3>';

        if (d.showStock !== 'false') {
          var state = this.stockState(product);
          var labels = {
            in: d.strInStock,
            backorder: d.strBackorder,
            special: d.strSpecial,
            out: d.strOutStock
          };
          html += '<p class="mc-card__stock mc-card__stock--' + state + '">' +
            '<span class="mc-card__dot" aria-hidden="true"></span>' +
            esc(labels[state] || d.strOutStock) + '</p>';
        }

        /* Price 0 renders a dash, exactly as the Liquid card does -
           an invented price is worse than none on a supply store. */
        html += '<div class="mc-card__prices">';
        if (product.price > 0) {
          if (product.price_varies) {
            html += '<span class="mc-card__from">' + esc(d.strFrom) + '</span>';
          }
          html += '<span class="mc-card__price">' +
            formatMoney(product.price, d.moneyFormat) + '</span>';
          if (onSale) {
            html += '<s class="mc-card__was">' +
              formatMoney(variant.compare_at_price, d.moneyFormat) + '</s>';
          }
        } else {
          html += '<span class="mc-card__price mc-card__price--none">—</span>';
        }
        html += '</div>';

        /* ── cta ── */
        html += '<div class="mc-card__cta">';

        if (!product.available) {
          html += '<button type="button" class="ic-btn ic-btn-tertiary mc-card__btn" disabled>' +
            esc(d.strSoldOut) + '</button>';

        } else if (variant && (product.variants || []).length === 1) {
          // Single variant: nothing to choose, so the card can add it.
          // product-card-mc.js intercepts the submit site-wide.
          html += '<form method="post" action="/cart/add" class="mc-card__form"' +
            ' enctype="multipart/form-data">' +
            '<input type="hidden" name="form_type" value="product">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="id" value="' + esc(variant.id) + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button type="submit" name="add" class="ic-btn ic-btn-tertiary mc-card__btn"' +
            ' data-url="' + esc(url) + '">' +
            '<span class="mc-card__btn-label">' + esc(d.strAdd) + '</span>' +
            '<span class="mc-card__btn-spin" aria-hidden="true"></span>' +
            '</button></form>';

        } else if (d.quickView === 'true') {
          var label = String(d.strQuickViewLabel || '').replace('[[title]]', product.title);
          html += '<div class="quick-view-wrapper mc-card__quick">' +
            '<button type="button" class="ic-btn ic-btn-tertiary mc-card__btn quick-view-button"' +
            ' aria-haspopup="dialog" aria-expanded="false"' +
            ' aria-label="' + esc(label) + '"' +
            ' data-product-id="' + esc(product.id) + '"' +
            ' data-url="' + esc(url) + '">' + esc(d.strOptions) + '</button></div>' +
            '<a class="ic-btn ic-btn-tertiary mc-card__btn mc-card__btn--fallback" href="' +
            esc(url) + '">' + esc(d.strOptions) + '</a>';

        } else {
          html += '<a class="ic-btn ic-btn-tertiary mc-card__btn" href="' + esc(url) + '">' +
            esc(d.strOptions) + '</a>';
        }

        html += '</div></div></article>';
        return html;
      }

      initSlider(count) {
        if (!this.slider) return;

        var mobileSlides = parseInt(this.slider.dataset.mobileSlides, 10) || 1;

        // Nothing scrolls at any breakpoint when the narrowest view
        // already shows everything.
        if (this.nav && count <= mobileSlides) this.nav.hidden = true;

        if (typeof Swiper === 'undefined') return;

        try {
          this.swiper = new Swiper('#' + this.slider.id, {
            spaceBetween: 20,
            slidesPerView: mobileSlides,
            allowTouchMove: true,
            watchOverflow: true,
            navigation: {
              prevEl: this.querySelector('.slider-btn-prev'),
              nextEl: this.querySelector('.slider-btn-next')
            },
            clickable: true,
            breakpoints: {
              520: { slidesPerView: mobileSlides },
              768: { slidesPerView: this.slider.dataset.tabletSlides },
              1024: { slidesPerView: this.slider.dataset.laptopSlides },
              1280: { slidesPerView: this.slider.dataset.smalldesktopSlides },
              1536: { slidesPerView: this.slider.dataset.desktopSlides }
            }
          });
        } catch (e) {
          console.log('Swiper JS is not defined');
          console.log(e);
        }
      }

      disconnectedCallback() {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    };

    // The theme editor re-runs section scripts on every change, and a
    // second define() call throws.
    if (!customElements.get('recently-viewed-products')) {
      customElements.define('recently-viewed-products', RecentlyViewed);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', function () {
      if (event.target.classList.contains('swiper-slide')) {
        const slideshowSwiperEl = event.target.closest('.swiper.hero-swiper');
        let slideIndex = event.target.dataset.swiperSlideIndex;
        if (slideshowSwiperEl) {
          slideshowSwiperEl.swiper.slideToLoop(slideIndex);
        }
      }
    });
    document.addEventListener('shopify:inspector:activate', function () {
      const inspectorSlideshows = document.querySelectorAll('.hero-swiper');
      for (let i = 0; i < inspectorSlideshows.length; i++) {
        const inspectorSlideshow = inspectorSlideshows[i];
        if (inspectorSlideshow.classList.contains('autoplay')) {
          inspectorSlideshow.swiper.autoplay.stop();
          const inspectorSlidshowToggle = inspectorSlideshow.querySelector('.autoplay-toggle');
          if (inspectorSlidshowToggle) {
            inspectorSlidshowToggle.querySelector('.pause-icon').classList.add('ic-display-none');
            inspectorSlidshowToggle.querySelector('.play-icon').classList.remove('ic-display-none');
          }
        }
      }
      document.addEventListener('shopify:section:load', stopAutoplay);
    });
    document.addEventListener('shopify:inspector:deactivate', function () {
      const inspectorSlideshows = document.querySelectorAll('.hero-swiper');
      for (let i = 0; i < inspectorSlideshows.length; i++) {
        const inspectorSlideshow = inspectorSlideshows[i];
        const inspectorSlidshowToggle = inspectorSlideshow.querySelector('.autoplay-toggle');
        if (inspectorSlideshow.classList.contains('autoplay') && !inspectorSlidshowToggle) {
          inspectorSlideshow.swiper.autoplay.start();
        }
      }
      document.removeEventListener('shopify:section:load', stopAutoplay);
    });

    function stopAutoplay(target) {
      if (target) {
        const targetSlideshow = target.target.querySelector('.hero-swiper');
        if (targetSlideshow) {
          if (targetSlideshow.classList.contains('autoplay')) {
            targetSlideshow.swiper.autoplay.stop();
            const targetSlideshowToggle = targetSlideshow.querySelector('.autoplay-toggle');
            if (targetSlideshowToggle) {
              targetSlideshowToggle.querySelector('.pause-icon').classList.add('ic-display-none');
              targetSlideshowToggle.querySelector('.play-icon').classList.remove('ic-display-none');
            }
          }
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  let vedio_count = document.querySelectorAll('.video-section');
  for (i = 0; i < vedio_count.length; i++) {
    let section_id = vedio_count[i].dataset.id;
    let button = document.querySelector('#video-section-btn-' + section_id);
    let template = document.querySelector('#template-' + section_id).content;
    let targetDiv = document.querySelector('#video-' + section_id);
    let deferred_media = document.querySelector('#deferred-media-' + section_id);

    button.addEventListener('click', function () {
      let clonedTemplate = template.cloneNode(true);
      targetDiv.appendChild(clonedTemplate);
      deferred_media.setAttribute('loaded', true);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
